// extracted by mini-css-extract-plugin
export default {"host":"Grid_host__8fhfs"};